import { render, staticRenderFns } from "./EditLiveAddAlertContact.vue?vue&type=template&id=34c6d002"
import script from "./EditLiveAddAlertContact.vue?vue&type=script&lang=js"
export * from "./EditLiveAddAlertContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports